import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import IMVReportTable from 'src/components/Conduct/IMVReport/IMVReportTable';
import IMVReportPage from 'src/components/Conduct/IMVReport/IMVReportPage';

const initialState: any = {
  showCMPArr: [
    {
      cmp: IMVReportTable,
      key: 'IMVReportTable',
      curruntlyActive: true
    },
    {
      cmp: IMVReportPage,
      key: 'IMVReportPage',
      curruntlyActive: false
    }
  ],
  selectedRowData: {}
};

export const imvReport = createSlice({
  name: 'imvReport',
  initialState,
  reducers: {
    setShowIMVReportCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedIMVReportData: (state: any, action: any) => {
      state.selectedRowData = action.payload;
    }
  }
});

export const { setShowIMVReportCMPArr, setSelectedIMVReportData } = imvReport.actions;
